import { Slide } from '@mui/material';
import { FC } from 'react';
import {
  SupplyChainConnector,
  SupplyChainItemType,
} from '../supplychain-types';
import SupplyChainConnectorBg from './SupplyChainConnectorBg';
import SupplyChainConnectorLayout from './SupplyChainConnectorLayout';
import SupplyChainConnectorsMore from './SupplyChainConnectorsMore';
import SupplyChainConnectorsRenderer from './SupplyChainConnectorsRenderer';

const SupplyChainToolConnectors: FC<SupplyChainToolConnectorsProps> = ({
  connectors,
  index,
  showCustomIcon,
  className,
}) => {
  return (
    <div className={className}>
      <SupplyChainConnectorLayout
        more={<SupplyChainConnectorsMore connectors={connectors} />}>
        <SupplyChainConnectorBg
          index={index}
          last={index === (connectors || []).length - 1}>
          <Slide
            in
            timeout={100 * index}
            direction='right'
            style={{ height: '100%' }}>
            <div>
              <SupplyChainConnectorsRenderer
                connectors={connectors}
                showCustomIcon={showCustomIcon}
                type={SupplyChainItemType.Category}
              />
            </div>
          </Slide>
        </SupplyChainConnectorBg>
      </SupplyChainConnectorLayout>
    </div>
  );
};

export interface SupplyChainToolConnectorsProps {
  connectors?: SupplyChainConnector[];
  showCustomIcon: boolean;
  className: string;
  index: number;
}

export default SupplyChainToolConnectors;
